export default "__VITE_ASSET__e27dcb29__"